export default "/images/upgrade_contact.webp"